<template>
  <div id="kt_footer" class="footer-wrapper">
    <!-- Background Animations -->
    <div class="footer-animations">
      <i class="fas fa-star icon-float i1"></i>
      <i class="fas fa-heart icon-float i2"></i>
      <i class="fas fa-award icon-float i3"></i>
      <i class="fas fa-crown icon-float i4"></i>
      <i class="fas fa-gem icon-float i5"></i>
    </div>

    <div class="footer-content container-fluid">
      <v-row wrap align="center" justify="center">
        <!-- Copyright -->
        <v-col cols="12" md="6" class="text-center text-md-left mb-2 mb-md-0">
          <div class="d-flex align-items-center justify-content-center justify-content-md-start">
            <span class="text-white-50 font-weight-medium mr-2">{{ CurrentYear }}©</span>
            <a href="https://jciindia.in" target="_blank" class="text-white text-hover-primary font-weight-medium">
              JCI India
            </a>
          </div>
        </v-col>

        <!-- Powered By -->
        <v-col cols="12" md="6" class="text-center mb-2 mb-md-0">
          <span class="text-white-50 font-weight-medium mr-2">Powered by</span>
          <a href="http://vaagai.org.in" target="_blank" class="text-white text-hover-primary font-weight-medium">
            Vaagai Tecknowledge
          </a>
        </v-col>

        <!-- Version Info -->
        <v-col cols="12" class="text-center mt-2">
          <div class="text-white-50 version-text">
            <span class="version-badge">v{{ AppVersion }}</span>
            <span v-if="VersionInfo" class="version-note">{{ VersionInfo }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { version } from "/package.json";
import common from "@/Common.vue";

export default {
  name: "KTFooter",
  mixins: [common],
  data() {
    return {
      AppVersion: version,
      VersionInfo: "",
      CurrentYear: new Date().getFullYear(),
    };
  },
  beforeMount() {
    console.log("beforeMount called");
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 5,
    };
    this.getPageDetails("VersionInfo", "", url2, condition2);
  },
};
</script>
<style scoped>
.footer-wrapper {
  background: linear-gradient(to right, #021a70, #0780f8);
  color: #fff;
  padding: 1.5rem 0;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
}

.footer-content {
  position: relative;
  z-index: 2;
}

.text-hover-primary:hover {
  color: #3699ff !important;
  text-decoration: none;
  transition: color 0.3s ease;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.65) !important;
}

.version-text {
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.version-badge {
  background: rgba(255, 255, 255, 0.1);
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.version-note {
  font-size: 0.75rem;
  max-width: 600px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.5);
}

/* Animations */
.footer-animations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
}

.icon-float {
  position: absolute;
  bottom: -30px;
  color: rgba(255, 255, 255, 0.05);
  font-size: 1.5rem;
  animation: floatUp 10s infinite linear;
}

.i1 {
  left: 10%;
  font-size: 1.2rem;
  animation-duration: 12s;
  animation-delay: 0s;
}

.i2 {
  left: 25%;
  font-size: 1.8rem;
  animation-duration: 8s;
  animation-delay: 2s;
}

.i3 {
  left: 50%;
  font-size: 1.5rem;
  animation-duration: 15s;
  animation-delay: 1s;
}

.i4 {
  left: 75%;
  font-size: 1.2rem;
  animation-duration: 10s;
  animation-delay: 3s;
}

.i5 {
  left: 90%;
  font-size: 1.6rem;
  animation-duration: 14s;
  animation-delay: 0s;
}

@keyframes floatUp {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0;
  }

  20% {
    opacity: 1;
  }

  80% {
    opacity: 1;
  }

  100% {
    transform: translateY(-100px) rotate(360deg);
    opacity: 0;
  }
}
</style>
